export default "__VITE_PUBLIC_ASSET__d0f2b064__"